import React from 'react'
import Menu from '../../components/menu/Menu'
import SocialMenu from '../../components/social/SocialMenu'
import './asidebar.css'

const AsideBar = () => {

      return (
            <div className="asidebar flex">
                  <Menu /> 
                  <SocialMenu />
            </div>
      )
}

export default AsideBar
